// lib/leasing/currentSignedLease.ts
export function currentSignedLease<T extends {
  id: string; unitId?: string; status: string;
  leaseStartDate?: string | Date | null; createdAt: string | Date;
}>(unit: { id: string; activeDealId?: string | null }, deals: readonly T[], at = new Date()): T | undefined {
  const signed = deals.filter(d => d.status === 'SIGNED' && (!d.unitId || d.unitId === unit.id));
  return signed.find(d => d.id === unit.activeDealId) ?? signed
    .filter(d => !d.leaseStartDate || new Date(d.leaseStartDate) <= at)
    .sort((a, b) =>
      (b.leaseStartDate ? new Date(b.leaseStartDate).getTime() : 0) - (a.leaseStartDate ? new Date(a.leaseStartDate).getTime() : 0) ||
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime() || a.id.localeCompare(b.id))[0];
}
